var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-grid",style:({
        'align-items': _vm.alignItems,
        'flex-direction': _vm.flexDirection,
        'justify-content': _vm.justifyContent,
        width: _vm.width,
    })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }